<script>
export default {
  name: 'UhCard',
  props: {
    shadow: {
      type: Boolean,
      default: false,
      required: false,
    },
    border: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>

<template>
  <div
    class="tw-rounded-lg tw-bg-white tw-p-3"
    :class="{
      'tw-shadow': shadow,
      'tw-border-1 tw-border-neutral-200': border,
    }"
  >
    <slot></slot>
  </div>
</template>
